export default {
  "content": "<path d=\"M7.274 7.133L3.293 12l3.981 4.867-1.549 1.266-4.5-5.5a1 1 0 010-1.266l4.5-5.5 1.55 1.266zM22.774 11.367a1 1 0 010 1.266l-4.5 5.5-1.549-1.266L20.707 12l-3.982-4.867 1.55-1.266 4.5 5.5z\" fill=\"#7B61FF\"/><path d=\"M7.25 10.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM12 10.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM16.25 10.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};